export default __webpack_public_path__ + "static/media/Chat_fill.3e72a738.svg";